import { render, staticRenderFns } from "./zTokIndex.vue?vue&type=template&id=fbab1034&"
import script from "./zTokIndex.vue?vue&type=script&lang=js&"
export * from "./zTokIndex.vue?vue&type=script&lang=js&"
import style0 from "./zTokIndex.vue?vue&type=style&index=0&id=fbab1034&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports